import { ComponentsOverrides, Theme } from '@mui/material';

export const getMuiDividerOverrides = (theme: Theme): ComponentsOverrides['MuiDivider'] => ({
  root: {
    borderColor: theme.themeColors.colorsDividerBorder,
  },
});
